var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoulette1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1570_504650)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 0C5.37264 0 0 5.37216 0 12.0001C0 18.6271 5.37264 23.9997 12.0001 23.9997C18.6274 23.9997 24 18.6271 24 12.0001C24 5.37211 18.6274 0 12.0001 0Z",
    fill: "#703D2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.001 2.24951C6.61564 2.24951 2.25 6.61477 2.25 12.0004C2.25 17.3853 6.61564 21.7509 12.001 21.7509C17.386 21.7509 21.7517 17.3854 21.7517 12.0004C21.7517 6.61477 17.386 2.24951 12.001 2.24951Z",
    fill: "#A56C42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9993 4.13574C7.65584 4.13574 4.13477 7.65648 4.13477 12.0003C4.13477 16.3434 7.65584 19.8644 11.9993 19.8644C16.3426 19.8644 19.8636 16.3434 19.8636 12.0003C19.8636 7.65652 16.3426 4.13574 11.9993 4.13574Z",
    fill: "#C6B8AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9996 4.50439C7.85984 4.50439 4.50391 7.86004 4.50391 12.0001C4.50391 16.1396 7.85984 19.4955 11.9996 19.4955C16.1392 19.4955 19.4952 16.1396 19.4952 12.0001C19.4952 7.86008 16.1392 4.50439 11.9996 4.50439Z",
    fill: "#BA7C49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.86106 7.70215C5.60736 8.06319 5.38949 8.44209 5.20703 8.83284L11.9992 12.0002L5.86106 7.70215Z",
    fill: "#CE2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.20756 8.83301C5.0221 9.2313 4.87341 9.64202 4.76172 10.0609L11.9998 12.0003L5.20756 8.83301Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.7015 6.70215C6.38732 7.01613 6.10798 7.35101 5.86133 7.70219L11.9995 12.0002L6.7015 6.70215Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.76242 10.0605C4.64957 10.4831 4.57455 10.9135 4.53711 11.3469L12.0005 12L4.76242 10.0605Z",
    fill: "#CE2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.70311 5.86182C7.35174 6.10842 7.01696 6.3882 6.70312 6.70184L12.0011 11.9999L7.70311 5.86182Z",
    fill: "#CE2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.86263 16.2979L12.0002 12.0003L5.20898 15.1672C5.39106 15.5583 5.60921 15.9365 5.86263 16.2979ZM12.0006 12L12.0002 12.0002L12.0008 12H12.0006Z",
    fill: "#CE2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.53626 11.3472C4.49814 11.7815 4.49858 12.2187 4.53607 12.6532L11.9997 12.0002L4.53626 11.3472Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.76172 13.9398C4.87351 14.3586 5.02196 14.7699 5.2079 15.1677L11.9997 12.0005L4.76172 13.9398Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.53711 12.653C4.57474 13.0862 4.64986 13.5168 4.76276 13.9394L12.0007 12.0001V12L4.53711 12.653Z",
    fill: "#CE2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2978 6.70215L12 11.9999L18.1381 7.70185C17.8916 7.35062 17.6118 7.01584 17.2978 6.70215Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.83176 5.20801C8.44078 5.39051 8.06246 5.60838 7.70117 5.86209L11.9992 12.0002L8.83176 5.20801Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6529 4.53662L12 12.0001L13.9394 4.76203C13.5169 4.64909 13.0862 4.57416 12.6529 4.53662Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1671 5.20801L12 12L16.298 5.8618C15.9369 5.60833 15.5583 5.38998 15.1671 5.20801Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.298 5.86182L12 12L17.2978 6.70227C16.9842 6.38839 16.649 6.10851 16.298 5.86182Z",
    fill: "#CE2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9394 4.76172L12 11.9998L15.1671 5.2078C14.7693 5.0221 14.358 4.87384 13.9394 4.76172Z",
    fill: "#CE2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.86133 16.2979C6.10798 16.6491 6.38776 16.9839 6.70174 17.2977L11.9994 12L5.86133 16.2979Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3477 4.53674L12.0007 12.0002L12.6536 4.53674C12.2191 4.49882 11.7821 4.49882 11.3477 4.53674Z",
    fill: "#357157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.347 4.53662C10.914 4.57421 10.4831 4.64909 10.0605 4.76208L12 12.0001L11.347 4.53662Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.06 4.76172C9.641 4.87351 9.23028 5.0221 8.83203 5.20756L11.9995 11.9998L10.06 4.76172Z",
    fill: "#CE2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12L19.2381 13.9393C19.3509 13.5168 19.4257 13.0861 19.4633 12.653L12 12Z",
    fill: "#CE2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12L18.1382 16.298C18.3917 15.9367 18.6097 15.5584 18.7922 15.167L12 12Z",
    fill: "#CE2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4637 11.3472L12 12L19.4633 12.653C19.5011 12.2184 19.5012 11.7814 19.4637 11.3472Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2381 10.061L12 12.0002L19.4637 11.3473C19.4258 10.9142 19.3509 10.4833 19.2381 10.061Z",
    fill: "#CE2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1381 7.70215L12 12.0002L18.7921 8.83298C18.6097 8.4417 18.3917 8.06348 18.1381 7.70215Z",
    fill: "#CE2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7921 8.83301L12 12.0002L19.2381 10.061C19.1263 9.64236 18.9775 9.23101 18.7921 8.83301Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12L17.2979 17.298C17.6118 16.9842 17.8916 16.6493 18.1382 16.298L12 12Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0007 12L6.70312 17.2977C7.01686 17.6117 7.35189 17.8915 7.70292 18.1384L12.0009 12H12.0007Z",
    fill: "#CE2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0005 12V12.0001L11.3477 19.4636C11.782 19.5013 12.2192 19.5013 12.6536 19.4634L12.0005 12Z",
    fill: "#CE2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.83398 18.7921C9.23203 18.9779 9.6431 19.1264 10.0618 19.238L12.0012 12.0001V12L8.83398 18.7921Z",
    fill: "#CE2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0605 19.2379C10.4832 19.3506 10.914 19.426 11.3472 19.4635L12 12L10.0605 19.2379Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.83191 18.7921L11.999 12.0003L7.70117 18.1385C8.06251 18.3917 8.44073 18.6098 8.83191 18.7921ZM11.999 12.0003L11.9991 12.0001V12L11.999 12.0003Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12L12.6531 19.4634C13.0865 19.426 13.5168 19.3507 13.9394 19.238L12 12Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12L15.1671 18.7921C15.5583 18.6098 15.9366 18.3917 16.2979 18.1383L12 12Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12L16.2979 18.1383C16.6492 17.8917 16.9842 17.6118 17.2979 17.298L12 12Z",
    fill: "#CE2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12L13.9394 19.238C14.3584 19.1262 14.7691 18.9779 15.1671 18.7921L12 12Z",
    fill: "#CE2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12L18.7923 15.167C18.9775 14.7691 19.1263 14.3582 19.2381 13.9393L12 12Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9996 5.66455C8.50063 5.66455 5.66406 8.50082 5.66406 12.0001C5.66406 15.4989 8.50058 18.3354 11.9996 18.3354C15.4985 18.3354 18.3351 15.4989 18.3351 12.0001C18.3351 8.50087 15.4986 5.66455 11.9996 5.66455Z",
    fill: "#BFAFA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0009 5.99756C8.68558 5.99756 5.99805 8.6849 5.99805 12.0004C5.99805 15.3154 8.68563 18.003 12.0009 18.003C15.316 18.003 18.0036 15.3154 18.0036 12.0004C18.0036 8.68485 15.316 5.99756 12.0009 5.99756Z",
    fill: "#C6854A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.97136 8.479C6.76351 8.77475 6.58502 9.08515 6.43555 9.40527L11.9999 12L6.97136 8.479Z",
    fill: "#E03636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.43557 9.40527C6.28363 9.73154 6.16183 10.068 6.07031 10.4112L11.9999 12L6.43557 9.40527Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.65898 7.65967C7.40165 7.91686 7.17275 8.19122 6.9707 8.47894L11.9992 12L7.65898 7.65967Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.07126 10.4111C5.97882 10.7573 5.91734 11.1099 5.88672 11.465L12.0009 11.9999L6.07126 10.4111Z",
    fill: "#E03636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.47938 6.97168C8.19152 7.17368 7.91725 7.40291 7.66016 7.65982L12.0004 12.0001L8.47938 6.97168Z",
    fill: "#E03636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.97297 15.5209L12.001 12.0002L6.4375 14.5946C6.58668 14.915 6.76541 15.2248 6.97297 15.5209ZM12.0014 12L12.001 12.0002L12.0015 12H12.0014Z",
    fill: "#E03636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.88661 11.4648C5.85537 11.8207 5.85571 12.1788 5.88642 12.5348L12.0007 11.9998L5.88661 11.4648Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.07031 13.5887C6.16188 13.9318 6.28353 14.2687 6.43581 14.5946L11.9998 12L6.07031 13.5887Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.88477 12.5349C5.91563 12.8898 5.97716 13.2426 6.06959 13.5888L11.9991 12.0001V12L5.88477 12.5349Z",
    fill: "#E03636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3401 7.66016L12 12.0002L17.0284 8.47914C16.8265 8.19142 16.5973 7.91716 16.3401 7.66016Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.40469 6.43555C9.08442 6.58506 8.77445 6.76356 8.47852 6.97141L11.9995 11.9998L9.40469 6.43555Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5349 5.88574L12 12L13.5888 6.07043C13.2427 5.97789 12.8898 5.91655 12.5349 5.88574Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5946 6.43604L12 12.0001L15.521 6.97161C15.2251 6.764 14.915 6.58512 14.5946 6.43604Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.521 6.97119L12 11.9997L16.3401 7.65971C16.0831 7.40257 15.8085 7.17334 15.521 6.97119Z",
    fill: "#E03636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5888 6.07031L12 11.9999L14.5946 6.43576C14.2686 6.28363 13.9317 6.16217 13.5888 6.07031Z",
    fill: "#E03636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.9707 15.5209C7.17275 15.8086 7.40199 16.0829 7.65918 16.3399L11.999 12L6.9707 15.5209Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4648 5.88556L11.9998 11.9998L12.5347 5.88556C12.1788 5.85455 11.8207 5.85455 11.4648 5.88556Z",
    fill: "#398764"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.466 5.88574C11.1112 5.91655 10.7583 5.97789 10.4121 6.07043L12.001 12L11.466 5.88574Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4103 6.07031C10.067 6.16193 9.73052 6.28363 9.4043 6.43557L11.9991 11.9999L10.4103 6.07031Z",
    fill: "#E03636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12L17.9295 13.5887C18.022 13.2426 18.0833 12.8897 18.114 12.5349L12 12Z",
    fill: "#E03636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12L17.0285 15.521C17.2362 15.225 17.4148 14.9152 17.5643 14.5945L12 12Z",
    fill: "#E03636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1144 11.4653L12 12.0002L18.114 12.5351C18.145 12.1791 18.1451 11.821 18.1144 11.4653Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9295 10.4116L12 12.0002L18.1144 11.4654C18.0833 11.1106 18.022 10.7576 17.9295 10.4116Z",
    fill: "#E03636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0284 8.479L12 12L17.5641 9.40542C17.4148 9.08491 17.2362 8.77504 17.0284 8.479Z",
    fill: "#E03636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5641 9.40527L12 11.9999L17.9295 10.4113C17.838 10.0683 17.7161 9.73135 17.5641 9.40527Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12L16.3401 16.3401C16.5973 16.0832 16.8265 15.8088 17.0285 15.521L12 12Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12L7.66016 16.3399C7.91716 16.5972 8.19162 16.8264 8.47919 17.0286L12.0002 12H12Z",
    fill: "#E03636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9996 12V12.0001L11.4648 18.1143C11.8207 18.1452 12.1788 18.1452 12.5347 18.1141L11.9996 12Z",
    fill: "#E03636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.40625 17.5642C9.73232 17.7164 10.0691 17.838 10.4121 17.9295L12.0009 12.0001V12L9.40625 17.5642Z",
    fill: "#E03636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4102 17.9294C10.7564 18.0218 11.1093 18.0836 11.4642 18.1142L11.999 12L10.4102 17.9294Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9994 12.0003L11.9995 12.0001V12L11.9994 12.0003ZM9.40488 17.5642L11.9994 12.0003L8.47852 17.0287C8.7746 17.2362 9.08442 17.4148 9.40488 17.5642Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12L12.535 18.1141C12.89 18.0835 13.2426 18.0218 13.5888 17.9295L12 12Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12L14.5946 17.5642C14.915 17.4149 15.2249 17.2362 15.5209 17.0286L12 12Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12L15.5209 17.0286C15.8087 16.8266 16.0831 16.5973 16.3401 16.3401L12 12Z",
    fill: "#E03636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12L13.5888 17.9295C13.932 17.8379 14.2685 17.7164 14.5946 17.5642L12 12Z",
    fill: "#E03636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12L17.5643 14.5945C17.7161 14.2685 17.838 13.9319 17.9296 13.5887L12 12Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 6.96786C12.2402 6.96786 12.4351 6.77295 12.4351 6.53251C12.4351 6.29208 12.2402 6.09717 11.9998 6.09717C11.7594 6.09717 11.5645 6.29208 11.5645 6.53251C11.5645 6.77295 11.7594 6.96786 11.9998 6.96786Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9874 6.14307C11.7722 6.14307 11.5977 6.31754 11.5977 6.53285C11.5977 6.74815 11.7721 6.92258 11.9874 6.92258C12.2027 6.92258 12.2027 6.14307 11.9874 6.14307Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9991 7.2373C9.3687 7.2373 7.23633 9.36953 7.23633 12.0001C7.23633 14.6303 9.3687 16.7627 11.9991 16.7627C14.6294 16.7627 16.7618 14.6303 16.7618 12.0001C16.7618 9.36948 14.6294 7.2373 11.9991 7.2373Z",
    fill: "#CEC0B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0007 7.43701C9.48053 7.43701 7.4375 9.47989 7.4375 12.0003C7.4375 14.5203 9.48053 16.5633 12.0007 16.5633C14.5209 16.5633 16.5639 14.5203 16.5639 12.0003C16.5639 9.47989 14.5209 7.43701 12.0007 7.43701Z",
    fill: "#D89450"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9327 8.93453C13.2766 7.27838 10.5915 7.27828 8.93535 8.93453C7.27935 10.5905 7.27935 13.2756 8.93545 14.9318C9.76168 15.7579 11.6684 14.6793 13.1662 13.185C14.6706 11.6843 15.7625 9.7644 14.9327 8.93453Z",
    fill: "#E09F65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0728 7.41992H11.9277V16.581H12.0728V7.41992Z",
    fill: "#685B51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.581 11.9272H7.41992V12.0724H16.581V11.9272Z",
    fill: "#685B51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1868 8.70968L8.70898 15.1875L8.8116 15.2901L15.2894 8.81229L15.1868 8.70968Z",
    fill: "#685B51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.8116 8.70989L8.70898 8.8125L15.1868 15.2903L15.2894 15.1877L8.8116 8.70989Z",
    fill: "#685B51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0006 13.4675C12.811 13.4675 13.468 12.8105 13.468 12.0001C13.468 11.1897 12.811 10.5327 12.0006 10.5327C11.1902 10.5327 10.5332 11.1897 10.5332 12.0001C10.5332 12.8105 11.1902 13.4675 12.0006 13.4675Z",
    fill: "#685B51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0004 12.6389C12.3533 12.6389 12.6394 12.3528 12.6394 11.9999C12.6394 11.6469 12.3533 11.3608 12.0004 11.3608C11.6474 11.3608 11.3613 11.6469 11.3613 11.9999C11.3613 12.3528 11.6474 12.6389 12.0004 12.6389Z",
    fill: "#4C4642"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9965 2.37256C11.9119 2.37256 11.7305 2.72988 11.7305 3.17069C11.7305 3.6115 11.8877 3.96882 11.9965 3.96882C12.1053 3.96882 12.2626 3.6115 12.2626 3.17069C12.2626 2.72988 12.0812 2.37256 11.9965 2.37256Z",
    fill: "#C1BDBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9965 2.37256C11.9119 2.37256 11.7305 2.72988 11.7305 3.17069C11.7305 3.6115 11.8877 3.96882 11.9965 3.96882C12.1053 3.96882 12.0812 2.37256 11.9965 2.37256Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9965 20.0283C11.9119 20.0283 11.7305 20.3856 11.7305 20.8265C11.7305 21.2673 11.8877 21.6246 11.9965 21.6246C12.1053 21.6246 12.2626 21.2673 12.2626 20.8265C12.2626 20.3856 12.0812 20.0283 11.9965 20.0283Z",
    fill: "#C1BDBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9965 20.0283C11.9119 20.0283 11.7305 20.3856 11.7305 20.8265C11.7305 21.2673 11.8877 21.6246 11.9965 21.6246C12.1053 21.6246 12.0812 20.0283 11.9965 20.0283Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8235 11.7329C20.3827 11.7329 20.0254 11.8901 20.0254 11.999C20.0254 12.1078 20.3827 12.265 20.8235 12.265C21.2643 12.265 21.6217 12.0836 21.6217 11.999C21.6217 11.9143 21.2643 11.7329 20.8235 11.7329Z",
    fill: "#C1BDBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8235 11.7329C20.3827 11.7329 20.0254 11.8901 20.0254 11.999C20.0254 12.1078 21.6217 12.0836 21.6217 11.999C21.6217 11.9143 21.2643 11.7329 20.8235 11.7329Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.16923 11.7329C2.72842 11.7329 2.37109 11.8901 2.37109 11.999C2.37109 12.1078 2.72842 12.265 3.16923 12.265C3.61004 12.265 3.96736 12.0836 3.96736 11.999C3.96736 11.9143 3.61004 11.7329 3.16923 11.7329Z",
    fill: "#C1BDBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.16923 11.7329C2.72842 11.7329 2.37109 11.8901 2.37109 11.999C2.37109 12.1078 3.96736 12.0836 3.96736 11.999C3.96736 11.9143 3.61004 11.7329 3.16923 11.7329Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8037 5.1923C18.7438 5.13246 18.3628 5.25683 18.0511 5.56853C17.7394 5.88024 17.5979 6.24404 17.6749 6.321C17.7519 6.39796 18.1157 6.25648 18.4274 5.94477C18.7391 5.63311 18.8635 5.25213 18.8037 5.1923Z",
    fill: "#C1BDBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8037 5.1923C18.7438 5.13246 18.3628 5.25683 18.0511 5.56853C17.7394 5.88024 17.5979 6.24404 17.6749 6.321C17.7519 6.39796 18.8635 5.25213 18.8037 5.1923Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.31923 17.6767C6.2594 17.6168 5.87847 17.7412 5.56676 18.0529C5.25506 18.3646 5.11357 18.7284 5.19053 18.8054C5.26749 18.8824 5.63134 18.7409 5.943 18.4292C6.25466 18.1175 6.37907 17.7365 6.31923 17.6767Z",
    fill: "#C1BDBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.31923 17.6767C6.2594 17.6168 5.87847 17.7412 5.56676 18.0529C5.25506 18.3646 5.11357 18.7284 5.19053 18.8054C5.26744 18.8824 6.37907 17.7365 6.31923 17.6767Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4274 18.0531C18.1157 17.7414 17.7519 17.5999 17.6749 17.6769C17.5979 17.7538 17.7394 18.1176 18.0511 18.4293C18.3628 18.741 18.7438 18.8654 18.8037 18.8056C18.8635 18.7457 18.7391 18.3648 18.4274 18.0531Z",
    fill: "#C1BDBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4261 18.0531C18.1144 17.7414 17.7506 17.5999 17.6736 17.6769C17.5967 17.7538 18.7425 18.8654 18.8023 18.8056C18.8622 18.7457 18.7378 18.3648 18.4261 18.0531Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.943 5.56823C5.63134 5.25652 5.26749 5.11503 5.19053 5.19199C5.11357 5.26895 5.25506 5.6328 5.56676 5.94446C5.87847 6.25617 6.2594 6.38058 6.31923 6.3207C6.37907 6.26081 6.25471 5.87994 5.943 5.56823Z",
    fill: "#C1BDBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.94172 5.56823C5.63007 5.25652 5.26621 5.11503 5.18925 5.19199C5.1123 5.26895 6.25812 6.38058 6.31796 6.3207C6.3778 6.26081 6.25343 5.87994 5.94172 5.56823Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4898 3.6073C15.0832 3.43698 14.6929 3.44385 14.6508 3.54422C14.6088 3.64459 14.8776 3.92771 15.2841 4.09803C15.6906 4.26839 16.0903 4.23918 16.123 4.16115C16.1558 4.08303 15.8963 3.77766 15.4898 3.6073Z",
    fill: "#C1BDBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4902 3.6073C15.0837 3.43698 14.6934 3.44385 14.6513 3.54422C14.6092 3.64459 16.0908 4.23922 16.1235 4.16115C16.1563 4.08303 15.8968 3.77766 15.4902 3.6073Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.70847 19.7948C8.30191 19.6244 7.9116 19.6314 7.86956 19.7317C7.82748 19.8321 8.09633 20.1152 8.50284 20.2856C8.90941 20.4559 9.30905 20.4267 9.34175 20.3487C9.3745 20.2706 9.11504 19.9652 8.70847 19.7948Z",
    fill: "#C1BDBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.70698 19.7948C8.30041 19.6244 7.9101 19.6314 7.86807 19.7317C7.82598 19.8321 9.30756 20.4267 9.34031 20.3486C9.37301 20.2706 9.11354 19.9652 8.70698 19.7948Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3977 14.602C20.2973 14.5599 20.0143 14.8287 19.8439 15.2353C19.6735 15.6418 19.7027 16.0415 19.7808 16.0742C19.8589 16.1069 20.1643 15.8474 20.3347 15.4409C20.5049 15.0344 20.4981 14.644 20.3977 14.602Z",
    fill: "#C1BDBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3974 14.602C20.297 14.5599 19.7024 16.0415 19.7805 16.0742C19.8586 16.1069 20.164 15.8474 20.3343 15.4409C20.5046 15.0343 20.4977 14.644 20.3974 14.602Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.21216 7.81878C4.11179 7.7767 3.82867 8.04555 3.65831 8.45206C3.48799 8.85863 3.51721 9.25827 3.59523 9.29097C3.6733 9.32372 3.97867 9.06421 4.14904 8.65769C4.3194 8.25113 4.31253 7.86082 4.21216 7.81878Z",
    fill: "#C1BDBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.21187 7.81875C4.11149 7.77667 3.51686 9.25824 3.59493 9.29099C3.67301 9.32374 3.97838 9.06422 4.14874 8.65771C4.31911 8.2511 4.31224 7.86079 4.21187 7.81875Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3619 8.51598C20.1949 8.10806 19.914 7.83694 19.8133 7.87815C19.7126 7.91941 19.7025 8.30963 19.8695 8.7176C20.0365 9.12556 20.3398 9.38754 20.4181 9.35547C20.4964 9.32331 20.5289 8.92395 20.3619 8.51598Z",
    fill: "#C1BDBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3623 8.51598C20.1953 8.10806 19.9144 7.83694 19.8137 7.87815C19.7129 7.91941 20.3401 9.3875 20.4184 9.35542C20.4968 9.32331 20.5293 8.92395 20.3623 8.51598Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.1197 15.1659C3.95267 14.7579 3.67182 14.4868 3.57112 14.5281C3.47036 14.5693 3.4603 14.9595 3.62732 15.3675C3.79435 15.7754 4.09759 16.0374 4.17595 16.0053C4.25427 15.9733 4.28677 15.5739 4.1197 15.1659Z",
    fill: "#C1BDBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.12006 15.1659C3.95303 14.7579 3.67218 14.4868 3.57147 14.5281C3.47071 14.5693 4.09795 16.0374 4.17626 16.0053C4.25463 15.9733 4.28713 15.5739 4.12006 15.1659Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.058 19.7605C16.0168 19.6598 15.6266 19.6497 15.2186 19.8168C14.8106 19.9838 14.5487 20.2871 14.5808 20.3654C14.6128 20.4438 15.0122 20.4762 15.4202 20.3092C15.8281 20.1422 16.0993 19.8613 16.058 19.7605Z",
    fill: "#C1BDBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0579 19.7604C16.0166 19.6597 14.5485 20.2869 14.5806 20.3652C14.6127 20.4436 15.0121 20.476 15.42 20.3091C15.828 20.142 16.0991 19.8611 16.0579 19.7604Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.40765 3.5184C9.36644 3.41764 8.97618 3.40753 8.56821 3.57456C8.16029 3.74159 7.89831 4.04483 7.93038 4.12314C7.96245 4.20151 8.36186 4.23396 8.76978 4.06699C9.17779 3.89996 9.44891 3.61911 9.40765 3.5184Z",
    fill: "#C1BDBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.40748 3.51825C9.36626 3.41749 7.89813 4.04468 7.93021 4.12299C7.96228 4.20136 8.36168 4.23381 8.7696 4.06683C9.17761 3.89981 9.44874 3.61896 9.40748 3.51825Z",
    fill: "#D8D8D8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1570_504650"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoulette1);
export default __webpack_public_path__ + "static/media/roulette1.9eb53d53b6cee3522e5321f6facec46e.svg";
export { ForwardRef as ReactComponent };